<template>
  <section class="bg-white md:bg-transparent md:grid md:grid-cols-12 lg:max-w-screen-xl lg:mx-auto xl:max-w-screen-2xl xl:px-12 lg:gap-x-16 mb-10">
    <div class="px-4 pt-8 pb-12 sm:px-12 sm:pt-12 md:bg-white xl:px-20 xl:pt-12 2xl:px-24 2xl:pt-12 md:col-span-10 md:col-start-2 md:rounded-t-2xl">
      <!--
        Vue 3's SFC compiler rejects a literal <script> tag inside <template> ("tags with side effect
        are ignored"). `<component is="script">` renders the identical DOM node/attributes without
        tripping that compile-time check; Cookiebot's own script looks for this exact node by id to
        inject the cookie declaration content in place.
      -->
      <component :is="'script'" id="CookiePolicy" :data-culture="culture" :src="`https://consent.cookiebot.com/${cookiebotId}/cd.js`" type="text/javascript" async />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  cookiebotId: { type: String, required: true },
})

const pageStore = usePageStore()
const culture = computed(() => (pageStore.page?.language ? pageStore.page.language.toUpperCase() : undefined))
</script>
